import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, Heart } from 'lucide-react';
import { Section } from './ui/Section';
export function StorySection() {
  return <Section background="cream" data-id="element-284">
      <div className="max-w-5xl mx-auto" data-id="element-285">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-[#D4AF37]/10" data-id="element-286">
          <div className="flex items-center gap-3 mb-8 text-[#FF6B6B]" data-id="element-287">
            <AlertCircle className="w-6 h-6" data-id="element-288" />
            <span className="font-bold tracking-wide uppercase text-sm" data-id="element-289">
              Si limpiar te roba la paz...
            </span>
          </div>

          <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-6" data-id="element-290">
            Querida mujer poderosa,
          </h2>

          <div className="space-y-6 text-lg text-gray-700 leading-relaxed mb-12" data-id="element-291">
            <p data-id="element-292">
              Si sientes que limpiar tu casa te está robando la paz, el tiempo,
              la energía y la alegría…{' '}
              <span className="font-semibold text-[#2C7A7B]" data-id="element-293">
                no es tu culpa.
              </span>
            </p>

            <div className="pl-6 border-l-4 border-[#D4AF37]/30 italic text-gray-600 space-y-2" data-id="element-294">
              <p data-id="element-295">No te falta disciplina.</p>
              <p data-id="element-296">No te falta organización.</p>
              <p data-id="element-297">No te falta fuerza de voluntad.</p>
            </div>

            <p className="font-medium text-xl text-gray-900" data-id="element-298">
              El problema no eres tú — es el método incorrecto.
            </p>

            <p data-id="element-299">
              Durante años nos hicieron creer que una casa impecable requiere
              limpiar todos los días, esforzarse al máximo y sacrificar vida
              personal. Pero esa idea es falsa.
            </p>

            <p data-id="element-300">
              Lo que realmente mantiene la casa limpia no es limpiar más fuerte…
              es usar los ingredientes correctos que siguen activos por días.
            </p>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="mb-12" data-id="element-301">
            <img src="https://cdn.magicpatterns.com/uploads/kK47aKPyMsnYaAZe6EHg3T/2.webp" alt="Antes: agotada por la limpieza. Después: paz real en casa" className="w-full h-auto rounded-2xl shadow-lg" loading="lazy" data-id="element-302" />
          </motion.div>

          <div className="pt-12 border-t border-gray-100" data-id="element-303">
            <div className="flex items-center gap-3 mb-6 text-[#2C7A7B]" data-id="element-304">
              <Heart className="w-6 h-6 fill-current" data-id="element-305" />
              <span className="font-bold tracking-wide uppercase text-sm" data-id="element-306">
                El día que todo cambió
              </span>
            </div>

            <div className="bg-[#FFF9F5] p-6 rounded-xl italic text-gray-700 mb-6" data-id="element-307">
              "Había pasado casi 3 horas limpiando. La casa quedó perfecta. Me
              senté en el sofá… Y alguien tiró una bolsa de juguetes en el piso.
              No lloré de cansancio. Lloré de derrota."
            </div>

            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-308">
              Ese día hice una promesa silenciosa: Encontrar una forma real de
              tener una casa impecable sin sacrificar mi vida.{' '}
              <span className="font-bold text-[#2C7A7B]" data-id="element-309">Y lo logré.</span>
            </p>
          </div>
        </motion.div>
      </div>
    </Section>;
}